import tw, { styled } from 'twin.macro';

const DragableBuilderStep = styled.div`
  ${tw`md:w-1/2 xl:w-1/3 flex flex-col items-center cursor-move h-full`}
`;

export default DragableBuilderStep;
